import useAuthUser from "../../hooks/useAuthUser"
import getGender from "../../utils/getGender"
import getExamVersion from "../../utils/getExamVersion"
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function TesAkademikFinish({ data }) {
    const router = useHistory();
    const { user } = useAuthUser();
    const [reviewUrl, setReviewUrl] = useState(null);

    useEffect(() => {
        if (user?.token) {
            setReviewUrl(`/review-soal?token=${user.token}`);
        }
    }, [user?.token]);

    const mapels = data?.mapels || [];
    const penilaian = data?.penilaian || null;

    const getMapelScore = (m) => {
        if (m.skor !== undefined && m.skor !== null) {
            return Math.round(Number(m.skor));
        }
        const nilaiObj = m.nilai || {};
        const scores = Object.values(nilaiObj);
        if (scores.length === 0) return 0;
        return Math.round(scores.reduce((a, b) => a + b, 0) / scores.length);
    };

    return (
        <>
            <div className="container mx-auto row items-center" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center">
                    <img src="/assets/images/login.svg" alt="" className="img-fluid w-100" style={{ maxWidth: "350px", objectFit: "contain" }} />
                    <div className="mt-5">
                        {penilaian ? (
                            <>
                                <div dangerouslySetInnerHTML={{ __html: penilaian }}></div>
                            </>
                        ) : (
                            <h3 className="mb-4" style={{ fontSize: "1.5rem", textTransform: "uppercase", lineHeight: 1.8, fontWeight: 700, }}>
                                Selamat Anda Telah Menyelesaikan Tes Akademik.
                            </h3>
                        )}
                    </div>
                </div>
                <div className="col-md-6 d-flex flex-column justify-content-center">
                    <div className="mt-2 border rounded p-5 bg-white">
                        <h1 className="fw-bold mb-5 text-center text-secondary" style={{ textTransform: "uppercase", fontSize: '1.5rem' }}>Ringkasan hasil ujian anda</h1>
                        <table className="table borderless" style={{ margin: "auto" }}>
                            <tbody>
                                <tr>
                                    <td>Nama</td>
                                    <td>{user?.nama_lengkap}</td>
                                </tr>
                                <tr>
                                    <td>No. Telepon</td>
                                    <td>{user?.no_tlp || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Alamat email</td>
                                    <td>{user?.email || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Tempat & Tanggal Lahir</td>
                                    <td>{user?.ttl || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>{getGender(user?.jenis_kelamin) || '-'}</td>
                                </tr>
                                <tr>
                                    <td>Versi Ujian</td>
                                    <td>{getExamVersion(user?.version) || '-'}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Navigation & Review Buttons */}
                        <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 mt-4">
                            <button
                                type="button"
                                onClick={() => router.push("/app")}
                                className="btn btn-outline-primary"
                                style={{
                                    borderRadius: '8px',
                                    padding: '12px 24px',
                                    fontWeight: '600',
                                    borderWidth: '2px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <i className="fas fa-arrow-left me-2"></i>
                                Kembali Kerjakan Ujian
                            </button>
                            {reviewUrl && (
                                <a
                                    href={reviewUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                    style={{
                                        background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                        border: 'none',
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontWeight: '600',
                                        textDecoration: 'none',
                                        color: 'white',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    <i className="fas fa-clipboard-list me-2"></i>
                                    Review Soal & Jawaban
                                </a>
                            )}
                        </div>
                        {reviewUrl && (
                            <div className="text-center mt-2">
                                <small className="text-muted">
                                    Halaman review soal dan jawaban akan terbuka otomatis
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {mapels.length > 0 && (
                <div className="row container mx-auto mt-3 mb-3 border rounded p-5 bg-white">
                    <div className="row mx-auto mt-2">
                        <h2 className="text-center mb-5">Hasil Tes Akademik</h2>
                    </div>
                    <div className="row mx-auto mt-2">
                        <Bar options={{
                            responsive: true,
                            plugins: {
                                legend: {
                                    display: false,
                                }
                            },
                            scales: {
                                x: {
                                    border: {
                                        display: false,
                                    },
                                    grid: {
                                        display: false,
                                    }
                                },
                                y: {
                                    border: {
                                        display: false
                                    },
                                    min: 0,
                                    max: 100,
                                }
                            }
                        }}
                            data={{
                                labels: mapels.map((m) => m.nama_mapel),
                                datasets: [
                                    {
                                        label: 'Nilai',
                                        data: mapels.map((m) => getMapelScore(m)),
                                        backgroundColor: 'rgb(54, 162, 235)',
                                        borderRadius: 10,
                                    },
                                ]
                            }}
                        />
                    </div>
                    <div className="row mx-auto my-5">
                        <table className="table table-bordered" style={{ margin: "auto" }}>
                            <thead>
                                <tr>
                                    <th className="text-left">Mata Pelajaran</th>
                                    <th className="text-center">Nilai</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mapels.map((m, index) => {
                                    const score = getMapelScore(m);
                                    return (
                                        <tr key={index}>
                                            <td className="text-left">{m.nama_mapel}</td>
                                            <td className="text-center">
                                                {m.has_answer ? score : <span className="badge bg-secondary">Belum dikerjakan</span>}
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr>
                                    <td className="text-left"><strong>Rata-rata</strong></td>
                                    <td className="text-center">
                                        <strong>
                                            {(() => {
                                                const completed = mapels.filter(m => m.has_answer);
                                                if (completed.length === 0) return 0;
                                                const total = completed.reduce((sum, m) => sum + getMapelScore(m), 0);
                                                return Math.round(total / completed.length);
                                            })()}
                                        </strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {mapels.length === 0 && data !== null && (
                <div className="row container mx-auto mt-3 mb-3 border rounded p-5 bg-white">
                    <div className="text-center">
                        <h3 className="text-secondary">Belum ada hasil ujian yang tersedia.</h3>
                        <p className="text-muted mt-3">Silakan selesaikan ujian terlebih dahulu.</p>
                    </div>
                </div>
            )}

            {/* Review Soal dan Jawaban - Inline */}
            {reviewUrl && (
                <div className="row container mx-auto mt-3 mb-3 border rounded p-5 bg-white">
                    <h2 className="text-center mb-4">
                        <i className="fas fa-clipboard-list me-2"></i>
                        Review Soal dan Pembahasan
                    </h2>
                    <iframe
                        src={reviewUrl}
                        style={{ width: '100%', minHeight: '600px', border: 'none' }}
                        title="Review Soal"
                    ></iframe>
                </div>
            )}
        </>
    )
}
